/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_TitleInputs */

const cs_listing_portals_title = /** @type {(inputs: Listing_Portals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portály pro inzerci`)
};

const en_listing_portals_title = /** @type {(inputs: Listing_Portals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing portals`)
};

/**
* | output |
* | --- |
* | "Listing portals" |
*
* @param {Listing_Portals_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_title = /** @type {((inputs?: Listing_Portals_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_title(inputs)
	return cs_listing_portals_title(inputs)
});